import React, { useState, useEffect } from "react";
import RenderWizardUI from "./RenderWizardUI";
import * as services from "../../../store/service";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import ResourcesTab from "../ResourcesTab";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as CyberRiskAction from "../../../store/cyberRiskProfile/actions";
import { Notification } from "../../common/Notification";
import LogoContainer from "../../common/LogoContainer";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../../store";

const CyberRiskProfileWizard = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [numberOfQuestion, setNumberOfQuestion] = useState(0);
    const [answers, setAnswers] = useState({} as any);
    const [questionaires, setQuestionaires] = useState({} as any);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const requestAssesmentSummary = (forcefullyRefresh: boolean) => dispatch(CyberRiskAction.actionCreators.requestAssesmentSummary(forcefullyRefresh));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const getQuestionaires = () => {
        setIsLoading(true);
        setIsSubmitted(false);

        services.getQuestionaires().then((data) => {
            setIsLoading(false);
            if (!data.HasError) {
                setQuestionaires(data);
                setNumberOfQuestion(data["Questions"].length);
            }
        });
    };

    const submitAnswers = (redirect: boolean) => {
        let shouldSubmit = false;
        let answerLength: number = Object.keys(answers).length;
        if (questionaires?.Questions?.length === answerLength) {
            shouldSubmit = true;
            for (let key of Object.keys(answers)) {
                if (answers[key] == null || answers[key] === "" || (isNaN(parseInt(answers[key])) === false && parseInt(answers[key])) < 0) shouldSubmit = false;
            }
        }
        if (shouldSubmit) {
            let answerList = [] as any;
            setIsSubmitted(true);

            for (let key of Object.keys(answers)) {
                let answer = {
                    QuestionId: key,
                    SelectedAnswers: [answers[key]],
                };
                if (Array.isArray(answers[key])) answer.SelectedAnswers = answers[key];
                answerList.push(answer);
            }

            services.submitAssessmentAnswers(answerList).then((data) => {
                if (!data.HasError) {
                    requestAssesmentSummary(true);
                    if (redirect) {
                        history.push("/resources/cyber-risk-profile");
                    }
                }
            });
        } else {
            if (redirect) {
                Notification({
                    type: "error",
                    title: "Warning",
                    message: "Please answer all the questions correctly to submit.",
                    duration: 5,
                });
            }
        }
    };

    useEffect(() => {
        getQuestionaires();
        return () => {
            if (isSubmitted === false) {
                submitAnswers(false);
            }
        };
    },[]);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const setAnswer = (ans: any) => {
        let key: string = Object.keys(ans)[0];
        answers[key] = ans[key];
        setAnswers(answers);
    };

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        Resources
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="2" />

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="shield-alt" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">Cyber Risk Profile Assessment</h2>
                                </div>
                            </div>
                            <div className="box-actions"></div>
                        </div>
                        {isLoading || isSubmitted ? (
                            <div className="box loading"></div>
                        ) : (
                            <div className="box-content">
                                <form id="form-question-1" className="margin-top-s">
                                    {questionaires?.Questions?.map((question: any, index: number) => (
                                        <RenderWizardUI
                                            key={`question-${question.Id}-${index}`}
                                            question={question}
                                            answer={answers[question.Id]}
                                            setAnswer={setAnswer}
                                            numberOfQuestion={numberOfQuestion}
                                        />
                                    ))}
                                </form>
                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <button type="button" className="btn-default btn-primary btn-min-width" onClick={() => submitAnswers(true)}>
                                            <span className="btn-text">Submit</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CyberRiskProfileWizard;
